import { NgModule} from '@angular/core';
import { MaterialModule,MdTabsModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FOCRequestsRoutingModule } from './foc-viewrequests-routing.module';
import { FOCviewDialog, FOCviewRequestAddComponent} from './foc-create/foc-create.component';
import { FOCviewRequestReturnComponent } from './foc-return/foc-return.component';
import { FOCviewRequestConfirmComponent } from './foc-confirm/foc-confirm.component';
import { FOCviewRequestsComponent} from './foc-viewrequests.component';
import { FileUploadModule } from '../fileUpload.module';
import { SOCDetailsModule } from '../socIdDetails/socIdDetails.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TranslateLoader, TranslateModule, TranslateStaticLoader } from 'ng2-translate';
import { Http } from '@angular/http';

@NgModule({
    imports: [
        MaterialModule,
        MdTabsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FOCRequestsRoutingModule,
        FileUploadModule,
        SOCDetailsModule,
        PdfViewerModule,
        TranslateModule
    ],
    declarations: [
        FOCviewRequestsComponent,
        FOCviewRequestAddComponent,
        FOCviewRequestReturnComponent,
        FOCviewRequestConfirmComponent,
        FOCviewDialog
    ],
    entryComponents: [FOCviewDialog],
    
    exports: [
        TranslateModule
    ]
})

export class FOCviewRequestsModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/FOCviewRequest/foc-viewrequests.module.ts